import { Action, createReducer, on } from '@ngrx/store';
import * as InAppNotificationPreferencesActions from 'src/app/in-app-notifications/store/actions/in-app-notification-preferences.actions';
import { InAppNotificationPreferencesState } from 'src/app/in-app-notifications/store/in-app-notification-preferences.state';

export const initialState: InAppNotificationPreferencesState = {
    loading: false,
    inAppNotificationPreferences: [],
    error: undefined
};

const reducer = createReducer(
    initialState,

    on(InAppNotificationPreferencesActions.getInAppNotificationPreferences, (state) => ({
        ...state,
        loading: true
    })),

    on(InAppNotificationPreferencesActions.getInAppNotificationPreferencesSuccess, (state, action) => ({
        ...state,
        loading: false,
        inAppNotificationPreferences: action.inAppNotificationPreferences
    })),

    on(InAppNotificationPreferencesActions.getInAppNotificationPreferencesFailure, (state, action) => ({
        ...state,
        inAppNotificationPreferences: [],
        loading: false,
        error: action.error
    })),

    on(InAppNotificationPreferencesActions.updateInAppNotificationPreference, (state) => ({
        ...state,
        loading: true
    })),

    on(InAppNotificationPreferencesActions.updateInAppNotificationPreferenceSuccess, (state) => ({
        ...state,
        loading: false
    })),

    on(InAppNotificationPreferencesActions.updateInAppNotificationPreferenceFailure, (state, action) => ({
        ...state,
        loading: false,
        error: action.error
    }))
);

export function inAppNotificationPreferencesReducer(
    state: InAppNotificationPreferencesState | undefined,
    action: Action
) {
    return reducer(state, action);
}
